export default {
  QINIU_URL: 'https://qn.feijing88.com/',
  LOTTERY_QINIU_URL: 'http://qn.365rich.com/',
  LOTTERY_QINIU_TOKEN: 'wJVyfxRH-bu913tD5RfnsOGqQEGDELSYxmQ3pXlf:jL1L3h-yKB6XKe90UHl3tYgszUo=:eyJzY29wZSI6ImJpbmd1by1jb21tb24iLCJkZWFkbGluZSI6LTkyMjMzNzIwMzUzMTM3MjE4Nzl9',
  ARTICLE_QINIU_URL: 'http://qn2.feijing88.com/',
  ARTICLE_QINIU_TOKEN: 'ntTgoTYKAYDzPKKlnXFlNT7okhjl37AGj4sEoLlp:wpzNUJAI9OEuh4ZoN1P6KeJMUSQ=:eyJzY29wZSI6ImZlaWppbmctYmluZ3VvIiwiZGVhZGxpbmUiOjM0MDQ4OTI0NzI5fQ=='
}



// WEBPACK FOOTER //
// ./src/config.js